import { render, staticRenderFns } from "./pop-card.vue?vue&type=template&id=4483afa6"
import script from "./pop-card.vue?vue&type=script&lang=ts"
export * from "./pop-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports